<template>
  <div class="contact-picker">
    <select :value="value" @input="onInput">
      <option :value="null">Choose contact</option>
      <option
        v-for="contact in contacts"
        :value="contact.id"
        >
        {{contact.name}}
      </option>
    </select>
    <div class="select-icon">
      <fa-icon icon="chevron-down"/>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex';

  export default {
    name: 'ContactPicker',
    props: {
      value: {
        type: String
      }
    },

    computed: {
      ...mapState({
        contacts: state => state.contacts.contacts
      }),
    },

    methods: {
      onInput(e) {
        this.$emit('input', e.target.value)
      }
    },

    created() {
      this.$store.dispatch('contacts/list');
    }
  }
</script>

<style lang="scss">
@import "./ContactPicker";
</style>
